






























import Vue, { PropType } from 'vue';
// import { OptionValue } from '@/modules/options';
import { OptionValue } from 'mostra';

// const japaneseSampleText = '日常的に使うための飽きのこない、それでいてちょっと気になるデザイン。0123456789';
// const englishSampleText = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

export default Vue.extend({
  name: 'GFontSelectBox',
  props: {
    name: {
      type: String as PropType<string>,
      required: true,
    },
    option: {
      type: Object as PropType<OptionValue>,
      required: true,
    },
    checked: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  data() {
    return {
      // japaneseSampleText: japaneseSampleText,
      // englishSampleText: englishSampleText,
    };
  },
});
